import { ReactNode } from "react";

import MemberLayout from "@/components/templates/layout/MemberLayout";
import NoHeaderLayout from "@/components/templates/layout/NoHeader";
import NonMemberLayout from "@/components/templates/layout/NonMemberLayout";
import { useIsLoggedIn } from "@/states/auth/selectors";

type Props = {
  children?: ReactNode;
  title?: string;
  menu?: ReactNode;
  noHeader?: boolean;
};

const Layout = ({ children, title = "", noHeader: noHeader }: Props) => {
  const isLoggedIn = useIsLoggedIn();
  return (
    <>
      {isLoggedIn ? (
        <MemberLayout title={title}>{children}</MemberLayout>
      ) : noHeader ? (
        <NoHeaderLayout>{children}</NoHeaderLayout>
      ) : (
        <NonMemberLayout>{children}</NonMemberLayout>
      )}
    </>
  );
};

export default Layout;
